var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNewYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    rx: 9,
    fill: "#FF2E3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.0073 10.9776C22.8147 10.258 22.2492 9.69249 21.5296 9.49987C20.2267 9.15039 14.9997 9.15039 14.9997 9.15039C14.9997 9.15039 9.77271 9.15039 8.46975 9.49987C7.75017 9.69249 7.18468 10.258 6.99205 10.9776C6.64258 12.2805 6.64258 15.0007 6.64258 15.0007C6.64258 15.0007 6.64258 17.7208 6.99205 19.0238C7.18468 19.7433 7.75017 20.3088 8.46975 20.5014C9.77271 20.8509 14.9997 20.8509 14.9997 20.8509C14.9997 20.8509 20.2267 20.8509 21.5296 20.5014C22.2492 20.3088 22.8147 19.7433 23.0073 19.0238C23.3568 17.7208 23.3568 15.0007 23.3568 15.0007C23.3568 15.0007 23.3554 12.2805 23.0073 10.9776Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3262 17.5079L17.6685 15.001L13.3262 12.4941V17.5079Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewYoutubeIcon);
export default __webpack_public_path__ + "static/media/new-youtube-icon.4a296d6c0ae23ddef077a54579423228.svg";
export { ForwardRef as ReactComponent };